/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Link_ExpiredInputs */



/**
* | output |
* | --- |
* | "This sign-in link has expired or was already used." |
*
* @param {Login_Link_ExpiredInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_link_expired = /** @type {((inputs?: Login_Link_ExpiredInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Link_ExpiredInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze aanmeldlink is vervallen of al gebruikt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce lien de connexion a expiré ou a déjà été utilisé.")
	return /** @type {LocalizedString} */ ("This sign-in link has expired or was already used.")
});